var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10911",
    "data-name": "Group 10911",
    transform: "translate(-6508 -2342)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2666",
    "data-name": "Ellipse 2666",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(6508 2342)",
    fill: "#00824f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_8666693_search_icon",
    "data-name": "8666693_search_icon",
    transform: "translate(6511 2345)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2665",
    "data-name": "Ellipse 2665",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    "data-name": "Line 1065",
    x1: 4.35,
    y1: 4.35,
    transform: "translate(16.65 16.65)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1e0736f5525b40110da43ebac97be8b8.svg";
export { ForwardRef as ReactComponent };